import React from 'react'
import MostrarInmuebles from './MostrarInmuebles'
import HeaderRoot from './HeaderRoot'

const Root = () => {
    return (
        <>
            <HeaderRoot />
            <MostrarInmuebles />

        </>
    )
}

export default Root